<div #ProjectsSearchWrapper *ngIf="!mobile">
  <div id="projectsSearchHeader">{{ 'Projects Search' | translate }}</div>
  <div id="projectsSearchBody">
    <mat-progress-bar mode="indeterminate" *ngIf="showProjectsSearchProgress"></mat-progress-bar>
    <ul>
      <li>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Search for Project ID' | translate }}</mat-label>
          <input matInput placeholder="https://demo.stacksclients.com" id="searchProjectDomain" (change)="updateSearchValue($event)" value="{{ this.searchProjectDomain }}" />
        </mat-form-field>
        <a href="#" class="stacksBtn blue" (click)="searchProjects()">{{ 'Search' | translate }}</a>
      </li>
      <li *ngFor="let result of response">
        <br />
        {{ 'Project ID' | translate }} : {{ result.project_id }}
        <br />
        {{ 'Order ID' | translate }} : {{ result?.order_id }}
        <br />
        {{ 'Status' | translate }} : {{ result?.status }}
        <br />
        {{ 'Type' | translate }} : {{ result?.type }}
      </li>
    </ul>
  </div>
</div>
